import { StatusApi } from "../../../../../app/apiSlice";
import { IDomaine, Source } from "../../../cdsApiSlice";
import SynchroniseNifiButton from "./SynchroniseNifiButton";
import "../DataSourceExterne.scss";
import { useSecureApplication } from "../../../../../hooks/KeycloackConnection";

interface IStatusNifiNotSynchronise {
  domaine?: IDomaine;
  source?: Source;
  status: StatusApi;
  functionSyncNifi: (data: Source | IDomaine) => void;
}


//Error message when sources or domaines are not synchronise with Nifi

const StatusNifiNotSynchronise = ({
  domaine,
  source,
  status,
  functionSyncNifi,
}: IStatusNifiNotSynchronise) => {
  const errorNifi = require("../../../../../assets/images/icon-warning.svg");
  const {hasAnyPerm} = useSecureApplication()

  return (
    <>
      <div>
        <div className="m-3  error mt-3">
          <div className="row">
            <img src={errorNifi.default} style={{ width: "4vh" }} />
          </div>
          <div className="row1 text-sm">
            {domaine ? `Le domaine ${domaine.libelle} ` : ""}
            {source ? `La source ${source.nom} ` : ""}
            n'est pas synchronisée avec NiFi
          </div>
          {domaine && hasAnyPerm("gds.manage") ? (
            <div className="row2 mt-2 ">
              <SynchroniseNifiButton
                status={status}
                NifiSynchronization={() => functionSyncNifi(domaine)}
              />{" "}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default StatusNifiNotSynchronise;
